import React, { useMemo } from 'react';
import MyMap from '../../components/mapComponent';
import Stack from '@mui/material/Stack';
import { connect } from 'react-redux';
import { ISystem } from '../../ts/interface/system.interface';
import {
  useLocationsRelayQuery,
  mapLocationsToIStations,
} from '../../hooks/stations/query/V2';

interface IStationLocationsMapProps {
  systemAccess?: number;
  system?: ISystem;
  systemLoaded?: boolean;
  organization_id?: string;
}

const StationLocationsMap = ({
  systemAccess,
  system,
  systemLoaded,
  organization_id,
}: IStationLocationsMapProps) => {
  const { data: locationsData, isLoading } = useLocationsRelayQuery(
    {
      organizationId: organization_id || undefined,
      systemId: !organization_id ? system?.gid : undefined,
    },
    {
      enabled: !!organization_id || systemLoaded,
      limit: 500, // Higher limit for map view to get all locations
    }
  );

  const stations = useMemo(() => {
    if (!locationsData) return [];
    return mapLocationsToIStations(locationsData);
  }, [locationsData]);

  return (
    <Stack>
      <MyMap
        stations={stations.map((station) => ({
          ...station,
          long: station.lng,
        }))}
        loaded={!isLoading}
        systemType={system?.hardware_type}
        systemAccess={systemAccess}
      />
    </Stack>
  );
};

const StationLocationsMapR = connect(
  (state: any) => ({
    system: state.system.current,
    systemAccess: state.admin.systemAccess,
    systemLoaded: state.system.isLoaded,
  }),
  () => ({})
)(StationLocationsMap);

export default StationLocationsMapR;
